interface ITableHeadProps {
  children?: React.ReactNode
}

export const TableHead = ({ children }: ITableHeadProps) => {
  return <thead className='fs-6 fw-bold bg-light'>{children}</thead>
}
